const config = require('../config.yaml');
const Promise = require('bluebird');
const Tools = require('./Tools.js');

/**
 * Класс для слайдера проектов
 */
class ProjectsSliderController {
	constructor(SliderController) {
		this.$projectSlider = $('#mainpage-project-slider');
		this.projectsSliderInstance = false;
		this.slides = this.$projectSlider.find('[data-projects-slide-id]');
		this.mainSliderController = SliderController;
		this.mainSliderInstance = this.mainSliderController.mainSliderInstance;
	}

	initSlider() {
		return new Promise((resolve, reject) => {
			if (this.$projectSlider.length) {
				let currentSlideIndex = 0;

				let $mainpageProjectsSliderNavArrows = $('#mainpage-projects-slider-nav-arrows'); //общий контейнер со стрелочками
				let $mainpageProjectsSliderNavArrowsPrev = $('#mainpage-projects-slider-nav-arrow-prev'); //стрелка на предыдущий слайд
				let $mainpageProjectsSliderNavArrowsNext = $('#mainpage-projects-slider-nav-arrow-next'); //стрелка на следующий слайд

				this.$projectSlider.swiper({
					mousewheelControl: false,
					keyboardControl: false,
					//loop: true,
					runCallbacksOnInit: false,
					speed: config.slidesInteractiveParams['slide-3']['sliderAnimationSpeed'],
					autoplay: config.slidesInteractiveParams['slide-3']['sliderAutoplaySpeed'],
					simulateTouch: false,
					slidesPerView: 1,
					onSlideChangeStart: (swiper) => {
						let index = swiper.activeIndex;
						let $slide = $(this.getSlide(index));
						let slideRealIndex = $slide.attr('data-projects-slide-id');

						if (index != 0) {
							$mainpageProjectsSliderNavArrowsPrev.fadeIn();
						} else {
							$mainpageProjectsSliderNavArrowsPrev.fadeOut();
						}

						//Выставляем play-stop контроллер в состояние Play
						// this.mainSliderController.setPlayStopControllerPlayState();

						//прошли круг, переходим на второй глобальный слайд
						if (Number(slideRealIndex) == 0 //нулевой слайд
							&& Number(currentSlideIndex != 0) // при этом предыдущий тоже не нулевой, т.е. когда страница только загрузилась
							&& Number(currentSlideIndex != 1)) { //при этом проверяем, что мы пришли не с обратного порядка, т.е. это не ручной проход
							//стопим, что бы не перескакивать на другие слайды, когда мы не на этом
							swiper.stopAutoplay();
							this.mainSliderInstance.slideNext();
						}

						//прокручиваем progress-bar на нужное положение для текущего слайда
						this.mainSliderController.progressBarController.fillSection(
							this.mainSliderController.getMainCurrentSlideID(),
							$slide.attr('data-projects-slide-id-for-progress-bar')
						);

						//переключение хеша в адресной строке
						let slideHash = this.mainSliderController.getFullHashBySlideID(this.mainSliderController.getMainCurrentSlideID());
						if (slideHash) {
							Tools.setPageHash(slideHash);
						}
					},
					onSlideChangeEnd: (swiper) => {
						let index = swiper.activeIndex;
						let $slide = $(this.getSlide(index));
						currentSlideIndex = $slide.attr('data-projects-slide-id');

					},
					preventLinksPropagation: true,
					preventLinks: true,
					onInit: (swiper) => {
						swiper.stopAutoplay();

						//этим обработчиком будет томрозить промотку слайдера, когдаы мы вне первого слайда
						$(document).on('stopMainpageSliderInnerInteractive', (e, interactivePackID) => {
							swiper.stopAutoplay();
							//сбрасываем текущий индекс активного слайда, что бы после перезапуска начать с начала
							currentSlideIndex = 0;
						});

						if (swiper.activeIndex == 0) {
							$mainpageProjectsSliderNavArrowsPrev.fadeOut();
						}

						//если существует контейнер со стрелочками
						if ($mainpageProjectsSliderNavArrows.length) {
							//клик стрелочки на предыдущий слайд
							$mainpageProjectsSliderNavArrowsPrev.on('click', () => {
								swiper.slidePrev();
								this.mainSliderController.setPlayStopControllerStopState();

								return false;
							});

							//клик стрелочки на следующий слайд
							$mainpageProjectsSliderNavArrowsNext.on('click', () => {
								swiper.slideNext();
								this.mainSliderController.setPlayStopControllerStopState();

								return false;
							});
						}

						this.projectsSliderInstance = swiper;
						resolve(swiper);
					}
				});
			}
		})
			.catch(e => {
				if (DEBUG) {
					Tools.log('ProjectsSliderController: initSlider', e);
				}
			});
	}

	/**
	 * Возвращает уникальные элементы слайдера
	 * @returns {*}
	 */
	getSliderItems() {
		return this.slides;
	}

	getSlide(index) {
		return this.slides[index];
	}

	/**
	 * Возвращает количество уникальных элементов слайдера
	 */
	getSliderItemsCount() {
		return this.slides.length;
	}

	/**
	 * Возвращает хеш из параметра текущего активного слайда
	 * @returns {*}
	 */
	getHashByCurrentSlide() {
		let index = this.projectsSliderInstance.activeIndex;


		if (index != undefined) {
			let $slide = $(this.getSlide(index));
			return $slide.attr('data-projects-slide-hash');

		} else {
			return false;
		}
	}

	/**
	 * Возвращает ID слайда по его хешу.
	 * @param addressHash - целевой хэш
	 * @returns {int} | {boolean}
	 */
	getSlideIDByHash(addressHash) {
		let $targetSlide = this.slides.filter((key, item) => {
			let slideHash = $(item).attr(`data-projects-slide-hash`);

			return (slideHash == addressHash)
				? true
				: (slideHash == '#' + addressHash);
		});

		return ($targetSlide.length) ? $targetSlide.attr('data-projects-slide-id') : false;
	}

	/**
	 * Переход к слайду по его хешу
	 * @param addressHash
	 */
	goToSlideByHash(addressHash) {
		let slideID = this.getSlideIDByHash(addressHash);
		if (slideID) {
			this.projectsSliderInstance.slideTo(slideID);
		}
	}

	/**
	 * Получить элемент по переданному ID
	 * @param id
	 */
	getSliderItemByID(id) {
		if (this.slides.length) {
			return this.slides.filter((key, item) => {
				return $(item).attr(`data-projects-slide-id`) == id;
			});
		} else {
			if (DEBUG) {
				Tools.log('ProjectsSliderController: getSliderItemByID', 'Не найден контейнер-слайдер');
			}
		}
	}

	getRealIndex() {
		let $slide = this.slides.filter((key, item) => {
			return $(item).hasClass(this.hourglassSliderInstance.params['slideActiveClass'])
				|| $(item).hasClass(this.hourglassSliderInstance.params['slideDuplicateActiveClass']);
		});

		if ($slide.length) {
			return $slide.attr('data-projects-slide-id');
		} else {
			return false;
		}
	}
}

module.exports = ProjectsSliderController;



// WEBPACK FOOTER //
// ./temp/components/mainpage/classes/ProjectsSliderController.js